import { Field } from "formik";
import qs from "qs";
import React from "react";
import styled from "styled-components";
import { Chip } from "../../../ui";
import { Multiselect } from "../../../ui/form_fields";
import { useQueryContext } from "../context";
import FormAccordion from "./accordion";

const ChipContainer = styled.span`
  span:first-child {
    border: 1px solid rgba(0, 0, 0, 0.23);
    color: black;
    position: relative;
    bottom: 3px;
  }
`;

const renderTitle = (data) => (
  <span>
    Tribunal
    {data.length > 0 && (
      <ChipContainer>
        <Chip
          label={data
            .map(({ nome }) => nome)
            .sort()
            .join(", ")}
        />
      </ChipContainer>
    )}
  </span>
);

const CourtSelectField = ({ fieldsData, onClear }) => {
  const { tribunais } = fieldsData;
  const { selectedCourts, updateSelectedCourts } = useQueryContext();
  const { data: courtsData } = selectedCourts;

  const handleChange = (values) => {
    if (values.length == 0) {
      onClear.call(null);
    } else if (values != courtsData) {
      const query = qs.stringify(
        { tribunal_ids: values.map(({ id }) => id) },
        {
          arrayFormat: "brackets",
        }
      );

      updateSelectedCourts({ data: values, query });
    }
  };

  return (
    <FormAccordion
      disabled={false}
      title={renderTitle(courtsData)}
      headerId="basic-header"
    >
      <fieldset className="p-0">
        <Field
          variation="outlined"
          key="tribunais"
          name="basic.tribunais"
          options={tribunais}
          component={Multiselect}
          onChange={(_ev, value, reason) => {
            if (value.length === 0 || reason === "remove-option") {
              handleChange(value);
            }
          }}
          onClose={handleChange}
          fullWidth
        />
      </fieldset>
    </FormAccordion>
  );
};

export default CourtSelectField;
